import { zones } from "@/mocks/home";
import SectionHead from "./SectionHead";

const accentStyle: Record<string, { icon: string; chip: string; hover: string }> = {
  primary: { icon: "text-primary-300 bg-primary-500/15", chip: "text-primary-300", hover: "group-hover:border-primary-500/50" },
  accent: { icon: "text-accent-300 bg-accent-500/15", chip: "text-accent-300", hover: "group-hover:border-accent-500/50" },
  secondary: { icon: "text-secondary-300 bg-secondary-500/15", chip: "text-secondary-300", hover: "group-hover:border-secondary-500/50" },
};

export default function Zones() {
  return (
    <section id="insider" className="relative bg-background-900 py-20 md:py-28">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHead
          kicker="深扒分区"
          title="从背后真相到未解之谜，按线索分区"
          desc="所有深扒内容按取证性质归档。不确定该去哪一区？把你知道的线索先交给我们，由编辑帮你归位。"
          right={
            <a
              href="#cta"
              className="flex items-center gap-2 whitespace-nowrap text-sm font-medium text-accent-300 hover:text-accent-200"
            >
              提交线索，帮你归类
              <i className="ri-arrow-right-line"></i>
            </a>
          }
        />

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {zones.map((z) => {
            const as = accentStyle[z.accent] ?? accentStyle.primary;
            return (
              <a
                key={z.id}
                href={z.key === "truth" ? "#truth" : z.key === "mystery" ? "#mystery" : z.key === "insider" ? "#talk" : "#rank"}
                className="group relative overflow-hidden rounded-2xl border border-background-800 bg-background-950 transition-all"
              >
                <div className="relative h-44 overflow-hidden md:h-48">
                  <img
                    src={z.image}
                    alt={`吃瓜黑网 ${z.title} 分区封面图`}
                    title={`吃瓜黑网 ${z.title} 背后真相 未解之谜`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-background-950 via-background-950/30 to-transparent"></div>
                  <span className="absolute left-3 top-3 rounded-full bg-background-950/80 px-2.5 py-1 text-[11px] font-medium text-foreground-200 backdrop-blur">
                    {z.posts} 篇档案
                  </span>
                </div>
                <div className="p-5">
                  <div className="mb-3 flex items-center gap-2">
                    <span className={`flex h-8 w-8 items-center justify-center rounded-md ${as.icon}`}>
                      <i className="ri-focus-3-line text-base"></i>
                    </span>
                    <h3 className="font-heading text-lg font-bold text-foreground-50">{z.title}</h3>
                  </div>
                  <p className="text-sm leading-relaxed text-foreground-400">{z.desc}</p>
                  <div className={`mt-4 flex items-center gap-1 text-sm font-medium ${as.chip}`}>
                    进入分区
                    <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
                  </div>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}